import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">热门榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            全网点阅热度排行，看看大家都在追什么漫画
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200 hover:border-primary-200 transition-all duration-300 mb-3 cursor-pointer"
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-heading text-lg font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.type}</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs text-foreground-500">{item.heat}</span>
                <span className={`w-5 h-5 flex items-center justify-center ${
                  item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  <i className={`text-sm ${item.trend === 'up' ? 'ri-arrow-up-fill' : 'ri-subtract-line'}`}></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}